import { Inject } from 'inversify-props'
import { AxiosRequestConfig } from 'axios'
import { DadosDeVendaProcessada } from '@/models'
import { DadosDeVendaServiceAdapter } from '@/usecases/data/adapters/DadosDeVendaServiceAdapter'

export class FindDadosDeVendasUsecase {
	@Inject('DadosDeVendasServiceAdapter')
	private dadosDeVendasService!: DadosDeVendaServiceAdapter

	find = async (params: ParametrosFindDadosDeVenda, config?: AxiosRequestConfig): Promise<DadosDeVendaProcessada[]> =>
		await this.dadosDeVendasService.find(params, config)
}

export type ParametrosFindDadosDeVenda = {
	lojas?: string[]
	pdvs?: string[]
	dataInicial: string
	dataFinal?: string
}
